import { useCallback, useEffect, useState } from 'react'

export const useGroupChat = (groupWatch) => {
  const [chatMessages, setChatMessages] = useState([])

  // We slice the message array to avoid UI issues caused by rendering a large array in an inverted FlatList on React Native Web.
  // Since the main purpose of the chat is realtime interaction, there is little value in keeping old messages anyway.
  const pickMostRecentMessages = (messages) => messages.slice(0, 200)

  const addNewMessage = useCallback(
    (message) => setChatMessages((prevMsgs) => pickMostRecentMessages([message, ...prevMsgs])),
    [setChatMessages],
  )
  // Store messages from the API response once only, so that we can simply add new messages from the websocket server
  useEffect(() => {
    if (groupWatch?.messageList) {
      setChatMessages(pickMostRecentMessages(groupWatch.messageList))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Boolean(groupWatch?.messageList)])

  return {
    addNewMessage,
    chatMessages,
  }
}
